var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "copyright_wrapper" }, [
      _c("div", [
        _vm._v("\n        "),
        _c(
          "a",
          { attrs: { href: "https://about.zcygov.cn/", target: "_blank" } },
          [_vm._v("关于我们")]
        ),
        _vm._v("    "),
        _c("span", { staticClass: "divider" }, [_vm._v("|")]),
        _vm._v("\n        "),
        _c(
          "a",
          {
            attrs: {
              href: "https://help.zcygov.cn/web/site_2/contact/index.html",
              target: "_blank"
            }
          },
          [_vm._v("联系方式")]
        ),
        _vm._v("    "),
        _c("span", { staticClass: "divider" }, [_vm._v("|")]),
        _vm._v("\n        "),
        _c(
          "a",
          {
            attrs: {
              href: "https://rule.zcygov.cn/web/site_1/2016/08/29/190.html",
              target: "_blank"
            }
          },
          [_vm._v("法律声明")]
        ),
        _vm._v("    "),
        _c("span", { staticClass: "divider" }, [_vm._v("|")]),
        _vm._v("\n        "),
        _c(
          "a",
          {
            attrs: {
              href: "https://rule.zcygov.cn/web/site_1/2016/09/22/201.html",
              target: "_blank"
            }
          },
          [_vm._v("隐私声明")]
        ),
        _vm._v("    \n  ")
      ]),
      _vm._v(" "),
      _c("div", [
        _c("span", [
          _vm._v(
            "\n      © 2016-2019 政采云有限公司 版权所有     增值电信业务经营许可证：浙B2-20160869    \n      "
          ),
          _c(
            "a",
            {
              attrs: {
                target: "_blank",
                href:
                  "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010602010281"
              }
            },
            [
              _c("img", {
                attrs: {
                  src:
                    "http://zcy-cdn.oss-cn-shanghai.aliyuncs.com/ZCY-comps-imgs/eeveesIMGs/nationalEmblem.png"
                }
              }),
              _vm._v("\n         浙公网安备 33010602010281号\n      ")
            ]
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-748c0067", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-748c0067","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyright.vue
// module id = null
// module chunks = 